import React from 'react';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     JSX.Element
 * @Author      Onur DOGUCU
 */
function MaximizeWindow({ action, variables, setOpenVariable }) {

    return (
        <></>
    )
}
export default MaximizeWindow;